export default "__VITE_ASSET__CoFsus7T__"